import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ChatMensajesService } from './chat-mensajes.service';
import { ChatService } from './chat.service';
import { ContactosUsersService } from './contactos-users.service';
import { ContactosService } from './contactos.service';
import { CountryService } from './country.service';
import { EstablecimientosService } from './establecimientos.service';
import { ProspectService } from './prospect.service';
import { SignatureService } from './signature.service';
import { UserService } from './user.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    UserService,
    CountryService,
    ProspectService,
    ContactosService,
    ChatService,
    ChatMensajesService,
    ContactosUsersService,
    EstablecimientosService,
    SignatureService,
  ],
})
export class ServicesModule {}
